import React from 'react'
import "./My_rewards_user_card.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faBitcoinSign } from '@fortawesome/free-solid-svg-icons'
import Pdf_lottie_animation from '../../../../animations/pdf_lottie_animation/Pdf_lottie_animation'

function My_rewards_user_card() {
    return (
        <>
            <div className='My_rewards_user_card_holder section_margin'>
                <div className="My_rewards_user_card">
                    <div className="count_holder">
                        <h6><FontAwesomeIcon icon={faAddressBook} /> OGN402996</h6>
                    </div>

                    <div className="points_holder">
                        <h6> <FontAwesomeIcon className='bitcoin' icon={faBitcoinSign} /> 2000 Points</h6>
                    </div>


                    <div className="pdf_lottie_holder">
                        <Pdf_lottie_animation />
                    </div>
                </div>


                <div className="user_holder">
                    <div className="user_img_holder">
                        <img src="" alt="" className='user_img' />
                    </div>
                </div>

            </div>
        </>
    )
}

export default My_rewards_user_card